<template>
<div class="border-position">
    <span class="border-linear border-top"></span>
    <span class="border-linear border-right"></span>
    <span class="border-linear border-bottom"></span>
    <span class="border-linear border-left"></span>
    <slot></slot>
</div>
</template>
<script>
export default {
    name : 'BorderWrap'
}
</script>
<style lang="less">
@import './BorderWrap.less';
</style>